<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import useCalculatorStore from '../../../store/calculator.js';

const calculator = useCalculatorStore();
const { period, selectedBases, selectedGroup, selectedUsers, tariff } = storeToRefs(calculator);

const rows = computed(() => {
  const items = [];
  const tariff_period = tariff.value.periods.find(p => p.period_id === period.value.id);
  if (tariff_period && tariff_period.price) {
    items.push({
      id: crypto.randomUUID(),
      label: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_TARIFF_PRICE'),
      hint: period.value.name,
      value: Intl.NumberFormat().format(tariff_period.price),
    });
  }
  const tariff_group = tariff.value.groups.find(g => g.group_id === selectedGroup.value.id);
  if (tariff_group) {
    if (tariff_group.price_per_user && selectedUsers.value > tariff.value.included_users) {
      let price = 0;
      if (Array.isArray(tariff_group.price_per_user)) {
        for (const price_per_user of tariff_group.price_per_user) {
          if (
            (
              (
                price_per_user.min
                && price_per_user.min <= selectedUsers.value - tariff.value.included_users
              )
              || null === price_per_user.min
            )
            && (
              (
                price_per_user.max
                && price_per_user.max >= selectedUsers.value - tariff.value.included_users
              )
              || null === price_per_user.max
            )
          ) {
            price = price_per_user.price;
            break;
          }
        }
      } else {
        price = tariff_group.price_per_user;
      }
      const item = {
        id: crypto.randomUUID(),
        label: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_MONTH_PRICE', {
          '#PRICE#': Intl.NumberFormat().format(price),
          '#AMOUNT#': Intl.NumberFormat().format(selectedUsers.value - tariff.value.included_users),
          '#MONTHS#': period.value.months,
        }),
        value: Intl.NumberFormat().format(
          price * (selectedUsers.value - tariff.value.included_users) * period.value.months
        ),
      };
      if (tariff.value.included_users > 0) {
        item.label = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_USERS', { '#AMOUNT#': item.label });
        item.hint = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_USERS_HINT', {
          '#AMOUNT#': selectedUsers.value,
          '#INCLUDED#': tariff.value.included_users,
        });
      } else {
        item.label = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_USERS_PRICE', { '#AMOUNT#': item.label });
      }
      items.push(item);
    }
    if (
      tariff_group.price_per_base
      && tariff.value.included_bases > 0
      && selectedBases.value > tariff.value.included_bases
    ) {
      const item = {
        id: crypto.randomUUID(),
        label: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_BASES_PRICE', {
          '#PRICE#': Intl.NumberFormat().format(tariff_group.price_per_base),
          '#AMOUNT#': Intl.NumberFormat().format(selectedBases.value - tariff.value.included_bases),
          '#MONTHS#': period.value.months,
        }),
        hint: Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_DETAIL_BASES_HINT', {
          '#AMOUNT#': Intl.NumberFormat().format(selectedBases.value),
          '#INCLUDED#': Intl.NumberFormat().format(tariff.value.included_bases),
        }),
        value: Intl.NumberFormat().format(
          tariff_group.price_per_base * (selectedBases.value - tariff.value.included_bases) * period.value.months
        ),
      };
      items.push(item);
    }
  }
  return items;
});
</script>

<template>
  <p class="cloud-calculator__summary-row" v-for="row in rows" :key="row.id">
    <span class="cloud-calculator__summary-label">
      {{ row.label }}
      <span v-if="row.hint">{{ row.hint }}</span>
    </span>
    <span class="cloud-calculator__summary-value">{{ row.value }}₸</span>
  </p>
</template>
